import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { slideInFromBottomAnimation } from '../scss/slide-in-from-bottom-animation';

@Component({
  selector: 'app-email-compose-more-actions',
  templateUrl: './email-compose-more-actions.component.html',
  animations: [slideInFromBottomAnimation],
  encapsulation: ViewEncapsulation.None
})
export class EmailComposeMoreActionsComponent {
  @Input()
  isSendButtonDisabled: boolean = true;

  @Output()
  sendMessage: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  cancelMessage: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  togglePanel: EventEmitter<any> = new EventEmitter<any>();

  public onTogglePanelClick(): void {
    this.togglePanel.emit();
  }

  public onSendMessageClick(): void {
    this.sendMessage.emit();
  }

  public onCancelMessageClick(): void {
    this.cancelMessage.emit();
  }
}
